module.exports = __webpack_public_path__ + "Youtube-71fc51e6.webp";